import { Medium } from "@bkry/bowline-components/Medium";
import {
  getTribeAttributes,
  getTribeRelationships,
} from "@bkry/bowline-redux/tribes";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import TribeTag from "./utils/TribeTag";

const TribeCard = ({ tribeId }, context) => {
  const tribeData = useSelector((state) => getTribeAttributes(state, tribeId));
  const tribeRelationships = useSelector((state) =>
    getTribeRelationships(state, tribeId)
  );
  const locale = useSelector((state) => state?.i18nState?.lang);

  return (
    <div className="bg-white text-bg-light d-flex flex-column p-2 rounded-4 h-100">
      <div className="ratio ratio-1x1 rounded-4 overflow-hidden position-relative ">
        {tribeData?.public_medium_thumbnail &&
          tribeData?.public_medium_metadata && (
            <Medium
              mediumData={{
                ...tribeData?.public_medium_thumbnail,
                ...tribeData?.public_medium_metadata,
              }}
              className="justify-content-center mb-3"
              altTitle={tribeData?.name}
              skipLazyLoading
              autoPlay
              loop
            />
          )}
        {!!tribeRelationships?.tags?.data?.length && (
          <div className="position-absolute top-0 end-0 d-flex justify-content-end flex-wrap pt-1 pe-1">
            {tribeRelationships.tags.data.map((tag) => (
              <span key={tag.id}>
                <TribeTag tagId={tag.id} />
              </span>
            ))}
          </div>
        )}
      </div>
      <p className="fw-bold fs-5 mt-2">{tribeData?.name}</p>
      <div className="d-flex flex-wrap gap-1 mb-3">
        {tribeData?.boundaries_ids?.map((boundaryId) => (
          <div
            key={boundaryId}
            style={{
              height: "32px",
              width: "32px",
              backgroundImage: tribeData?.boundaries_samples[boundaryId]
                ?.thumbnail_url
                ? `url(${tribeData.boundaries_samples[boundaryId].thumbnail_url})`
                : undefined,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
            className={classNames(
              "rounded",
              !tribeData?.boundaries_samples[boundaryId]
                ? tribeData?.boundaries_met_by_current_user?.includes(
                    boundaryId
                  )
                  ? "bg-success"
                  : "bg-dark"
                : ""
            )}
          />
        ))}
      </div>
      <Link
        to={`/${locale}/community/membershiptiers/${tribeId}`}
        className="btn btn-secondary mt-auto"
      >
        {context.t("Tier Details")}
      </Link>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
TribeCard.contextTypes = {
  t: PropTypes.func,
};

TribeCard.propTypes = {
  tribeId: PropTypes.string,
};
/** export the component as redux connected component */
export default TribeCard;
